import { Component, Input } from '@angular/core';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { LoyaltyProgram } from 'src/app/assabil-sales/models/entities/loyalty-program';
import { SpecificDanoneService } from 'src/app/assabil-sales/services/specific_danone_service';



@Component({
  selector: 'loyalty-quality-partner-list',
  templateUrl: './loyalty-quality-partner-list.component.html',
  styleUrls: ['./loyalty-quality-partner-list.component.scss']
})
export class LoyaltyQualityPartnerListComponent extends BasePage2<LoyaltyProgram> {

  
  @Input() periodActiveDay    : Date;
  @Input() loyaltyProgram     : string;
  @Input() geoAreaCode        : string;
  @Input() kpi                : string;

  // Filter fields
  // -------------------------------------------------------------------------------------
  isPrivilege           : boolean;
  withAbusedAsset       : boolean;
  withVisibleAsset      : boolean;
  withReachableAsset    : boolean;
  withClosedPartner     : boolean;
  withDeniedVisit       : boolean;
  withOtherAnomaly      : boolean;

  // -------------------------------------------------------------------------------------
  loyaltyQualityPartners : any[] = [];
  // -------------------------------------------------------------------------------------

  title = "";
  // -------------------------------------------------------------------------------------

  
//--------------------------------------------------------------------------------------------------------

  constructor(
      protected toastr            : ToastrService,
      protected router            : Router,
      protected baseService       : BaseService,
      protected leanUtilsService  : LeanUtilsService,
      protected specificDanoneService    : SpecificDanoneService,
      protected location          : Location) {
      super(toastr, router, baseService, leanUtilsService, location);

      this.entityName = "loyaltyQualityPartner";
  }
//--------------------------------------------------------------------------------------------------------

  
//--------------------------------------------------------------------------------------------------------
  ngOnInit() {
   
    if (! this.embeded) return;
    this.loadData();
    this.title = "Détail des Clients " + this.loyaltyProgram;
  }
//--------------------------------------------------------------------------------------------------------

//--------------------------------------------------------------------------------------------------------
getRows(): LoyaltyProgram[] {
      return this.loyaltyQualityPartners;
  }
//--------------------------------------------------------------------------------------------------------



//--------------------------------------------------------------------------------------------------------
loadData() {

  this.isPrivilege        = false;
  this.withAbusedAsset    = false;
  this.withVisibleAsset   = false;
  this.withReachableAsset = false;
  this.withClosedPartner  = false;
  this.withDeniedVisit    = false;
  this.withOtherAnomaly   = false;
 
  if (this.kpi === "Privilege")
    this.isPrivilege = true;

  if (this.kpi === "AssetAbused")
    this.withAbusedAsset = true;
  
  if (this.kpi === "AssetVisible")
    this.withVisibleAsset = true;

  if (this.kpi === "AssetReachable")
    this.withReachableAsset = true;
    
  if (this.kpi === "ClosedPartner")
    this.withClosedPartner = true;
  
  if (this.kpi === "OtherAnomaly")
      this.withOtherAnomaly = true;
  
   this.specificDanoneService.danoneLoyaltyQualityPartnersGet(this.periodActiveDay, this.loyaltyProgram, this.geoAreaCode, 
    this.isPrivilege, this.withAbusedAsset, this.withVisibleAsset, this.withReachableAsset, this.withClosedPartner,
    this.withDeniedVisit, this.withOtherAnomaly).then(result => {
      this.loyaltyQualityPartners = result;
  })
}
//--------------------------------------------------------------------------------------------------------

}

